import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CountUp from 'react-countup';
import { CommonBadgeGenerate } from '../Components/commonBadge';

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },

    card: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        paddingInlineStart: '10px',
        borderRadius: '10px',
        boxShadow: ' 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
        maxHeight: 300,
        height: 190,
        marginTop: 10
    },
    title: {
        fontSize: 15,
        color: "#229954"
    },
    titleMin: {
        fontSize: 30,
        alignContent: 'center'
    },
    titleSecondary: {
        fontSize: 15,
        alignContent: 'center'
    },
});

export const ActivePluckersGrid = ({ data }) => {
    const classes = useStyles();

    return (

        <Card className={classes.card} boxShadow={3}>
            <CardContent>
                <CommonBadgeGenerate
                    cardTitle={
                        <div className={classes.title} color="textSecondary">
                            <b>Active Pluckers</b>
                        </div>
                    }
                    badgeName={"E"}
                />

                <br />
                <Grid style={{ marginTop: '7px' }} container spacing={3}>

                    <Grid item xs={6} align="center" >

                        <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                            <b>Daily</b>
                        </Typography>
                        <Typography className={classes.titleMin} color="textSecondary" component="h2">
                            <CountUp separator=',' end={data.dailyActivePluckers} duration={3} />
                        </Typography>

                    </Grid>

                    <Grid item xs={6} align="center">

                        <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                            <b>Monthly</b>
                        </Typography>
                        <Typography className={classes.titleMin} color="textSecondary" component="h2">
                            <CountUp separator=',' end={data.monthlyActivePluckers} duration={3} />
                        </Typography>

                    </Grid>
                </Grid>
            </CardContent>

        </Card>

    );

}